<ul nz-menu (nzClick)="onItemClick()">
  <ng-container *ngIf="isLoggedIn$ | async">
    <li nz-menu-item *ngIf="profile$ | async as profile" class="profile-menu-item" (click)="onProfile()">
      <div nz-row>
        <div nz-col nzSpan="5">
          <i nz-icon nzType="icons/fontawesome/regular:user"></i>
        </div>
        <div nz-col nzSpan="19" class="profile-name" >
          <span class="name">{{profile.name}}</span>
          <span class="email">{{profile.email}}</span>
        </div>
      </div>
    </li>
    <li nz-menu-divider></li>
  </ng-container>
  <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menuLinks$ | async }"></ng-container>
  <ng-template #menuTpl let-menus>
    <ng-container *ngFor="let menu of menus">
      <li *ngIf="!menu.children" nz-menu-item>
        <ng-container *ngIf="!!menu.external; else internalTpl">
          <a href="{{menu.url}}" target="_blank">{{menu.name | titlecase}}</a>
        </ng-container>
        <ng-template #internalTpl>
          <ng-container *ngIf="menu.url; else commandTpl">
            <a *ngIf="menu.fullDocumentNavigation; else routerNavigation" [href]="menu.url">{{menu.name | titlecase}}</a>
            <ng-template #routerNavigation><a [routerLink]="menu.url" routerLinkActive="active">{{menu.name | titlecase}}</a></ng-template>
          </ng-container>
        </ng-template>
        <ng-template #commandTpl>
          <a (click)="menu.command()">{{menu.name | titlecase}}</a>
        </ng-template>
      </li>
      <li *ngIf="menu.children" nz-submenu [nzTitle]="menu.name">
        <ul>
          <ng-container *ngTemplateOutlet="menuTpl; context: { $implicit: menu.children }"></ng-container>
        </ul>
      </li>
    </ng-container>
    <li nz-menu-divider></li>
    <li nz-menu-item *ngIf="isLoggedOut$ | async" (click)="onCreateAccount()">Register</li>
    <li nz-menu-item *ngIf="isLoggedOut$ | async" (click)="onLogin()">Log In</li>
    <li nz-menu-item *ngIf="isLoggedIn$ | async" (click)="onLogout()">Log Out</li>
  </ng-template>
</ul>
